import { render, staticRenderFns } from "./ButtonLoader.vue?vue&type=template&id=0529832f&scoped=true&"
import script from "./ButtonLoader.vue?vue&type=script&lang=js&"
export * from "./ButtonLoader.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLoader.vue?vue&type=style&index=0&id=0529832f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0529832f",
  null
  
)

export default component.exports